import React, { FunctionComponent } from 'react';

import { NativeAppBanner } from '../../../../../components';
import { ErrorPage } from '../../../../../components/error-page';
import { ErrorPageType } from '../../../../../components/error-page/types';
import { Header } from '../../../../../components/header';
import { Notifications, Pages } from './components';

interface DefaultViewProps {
    hiddenHeader: boolean;
    withChat?: boolean;
    errorPageType: ErrorPageType | null;
    onCallOverlayHide?: () => void;
    isPlanningDisabled?: boolean;
    shouldShowNativeAppBanner: boolean;
}

export const DefaultView: FunctionComponent<DefaultViewProps> = ({
    hiddenHeader,
    withChat,
    errorPageType,
    onCallOverlayHide,
    isPlanningDisabled,
    shouldShowNativeAppBanner,
}) => {
    return (
        <>
            {errorPageType ? (
                <>
                    {errorPageType !== ErrorPageType.UNSUPPORTED_TOUCH && <Header hidden={hiddenHeader} />}
                    {shouldShowNativeAppBanner && <NativeAppBanner />}
                    <ErrorPage />
                </>
            ) : (
                <>
                    <Header hidden={hiddenHeader} />
                    {shouldShowNativeAppBanner && <NativeAppBanner />}
                    <Pages
                        isPlanningDisabled={isPlanningDisabled}
                        onCallOverlayHide={onCallOverlayHide}
                        withChat={withChat}
                    />
                </>
            )}
            <Notifications withChat={withChat} />
        </>
    );
};
